import { Link } from '@material-ui/core';
import { SPACES } from 'common/constants/sizes';
import { navigateBookDemoClick } from 'common/utils/utils';
import UpgradeEmptyState from 'components/base/UpgradeEmptyState';
import { GrayBackground } from 'components/base/layout-components';
import characterConnectGoalsImg from 'images/characters/character-connect-goals.svg';
import upgradeEmptyStateImg from 'images/goals-empty-state.jpg';
import styled from 'styled-components';

const StyledBackground = styled(GrayBackground)`
  padding-top: ${SPACES.large};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
`;

const TeamGoalsUpgradeEmptyState = () => (
  <StyledBackground>
    <UpgradeEmptyState
      EmptyStateImg={upgradeEmptyStateImg}
      title='Upgrade to see the Team Goals'
      info={
        <>
          Team Goals help your team <br />
          continuously improve. <br />
          <Link
            href='https://linearb.helpdocs.io/article/93hjd4drzc-what-are-goals'
            target='_blank'
          >
            Learn more
          </Link>
        </>
      }
      RightSideLogo={() => (
        <img src={characterConnectGoalsImg} alt='' height='200' width='200' />
      )}
      buttons={[
        {
          text: 'Upgrade',
          onClick: () => {
            navigateBookDemoClick();
          }
        }
      ]}
    />
  </StyledBackground>
);

export default TeamGoalsUpgradeEmptyState;
